import store from '@/store/index';
import isEqual from 'lodash/isEqual';

/*
 * Access authorization directive
 * Show an element if the current staff has the right permissions
 * @param hide boolean - If true, hide the element instead of showing it
 * @param destroy boolean - Destroy the DOM element if not authorized
 */
async function authorize(el, binding) {
  // ODMPPHE:
  // Si la directiva se configura con 'update' y en ella directiva se ejecuta algo de manera asíncrona
  // (por ejemplo: consultar al servidor para una autorización)
  // la directiva se volverá a llamar infinitamente mientras siga exisitendo código asíncrono en su interior
  //
  // Con isEqual nos aseguramos de que aunque entre de nuevo, no ejecute el código posterior.
  // Por tanto, la ejecución será síncrona, y de este modo evitamos que vuelva a ejecutarse y provoque un bucle infinito.
  if (isEqual(binding.value, binding.oldValue)) {
    return;
  }
  const permission = binding.value;
  const modifiers = binding.modifiers;
  const hideOnAccessGranted = modifiers.hide === true;
  const destroy = modifiers.destroy === true;
  el.style.visibility = hideOnAccessGranted ? 'visible' : 'hidden';
  const accessGranted = await store.dispatch('authorization/AUTHORIZE', permission);
  if (accessGranted) {
    el.style.visibility = hideOnAccessGranted ? 'hidden' : 'visible';
    return;
  }
  // Destroy the DOM element if specified
  if (destroy) {
    el.remove();
  }
}
export default {
  name: 'authorized',
  bind: authorize,
  update: authorize,
};
